import { render, staticRenderFns } from "./editAccident.vue?vue&type=template&id=280dd17c&scoped=true"
import script from "./editAccident.vue?vue&type=script&lang=js"
export * from "./editAccident.vue?vue&type=script&lang=js"
import style0 from "./editAccident.vue?vue&type=style&index=0&id=280dd17c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280dd17c",
  null
  
)

export default component.exports